import { useEffect, useState } from 'react';
import { loadConfig, type AppConfig } from './config.js';

/**
 * Phase 0 placeholder. Proves the deployment path end to end: the bundle is built
 * inside `cdk deploy`, served from CloudFront, and reads its backend identifiers from
 * the config.json that CDK generated. Phase 1 replaces this with the Today screen.
 */
export function App(): React.JSX.Element {
  const [config, setConfig] = useState<AppConfig | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    loadConfig()
      .then(setConfig)
      .catch((e: unknown) => {
        setError(e instanceof Error ? e.message : String(e));
      });
  }, []);

  return (
    <main
      style={{
        fontFamily: 'system-ui, sans-serif',
        // The whole UI is built for tremor: large type, generous spacing, no small targets.
        fontSize: '20px',
        lineHeight: 1.5,
        padding: '2rem',
        maxWidth: '40rem',
        margin: '0 auto',
      }}
    >
      <h1 style={{ fontSize: '1.6em' }}>Med Log</h1>
      {error !== undefined && <p style={{ color: '#b00020' }}>Configuration error: {error}</p>}
      {config === undefined && error === undefined && <p>Loading…</p>}
      {config !== undefined && (
        <>
          <p>Deployment is wired end to end.</p>
          <p style={{ color: '#555', fontSize: '0.8em' }}>
            Environment {config.env} · region {config.region}
          </p>
        </>
      )}
    </main>
  );
}
